import type {MessageContentBuildWorkflow, WorkflowBuild, WorkflowBuildPurpose} from "./types";

export const BUILD_WORKFLOW_TOOL_NAME = "build_workflow";

const isRecord = (value: unknown): value is Record<string, unknown> =>
  typeof value === "object" && value != null && !Array.isArray(value);

const asTrimmedString = (value: unknown): string | undefined =>
  typeof value === "string" && value.trim() ? value.trim() : undefined;

const asPurpose = (value: unknown): WorkflowBuildPurpose | undefined =>
  value === "after_call" || value === "tool" ? value : undefined;

/** Accepts the Wingman tool input, or the nested C# `{ workflow }` shape. */
export function workflowBuildFromToolInput(input: unknown): WorkflowBuild | null {
  if (!isRecord(input)) return null;
  const source = isRecord(input.workflow) ? input.workflow : input;
  const description = asTrimmedString(source.description);
  if (!description) return null;
  return {
    description,
    ...(asTrimmedString(source.suggestedName)
      ? {suggestedName: asTrimmedString(source.suggestedName)}
      : {}),
    ...(asPurpose(source.purpose) ? {purpose: asPurpose(source.purpose)} : {}),
  };
}

export function messageContentFromBuildWorkflowTool(
  callId: string,
  input: unknown
): MessageContentBuildWorkflow | null {
  const workflow = workflowBuildFromToolInput(input);
  if (!workflow) return null;
  return {
    type: "build_workflow",
    callId,
    functionName: BUILD_WORKFLOW_TOOL_NAME,
    parameters: isRecord(input) ? input : {},
    workflow,
  };
}

export function shouldAutoStartWorkflowHandoff(params: {
  purpose?: WorkflowBuildPurpose;
  canApprove: boolean;
  alreadyLinked: boolean;
}): boolean {
  return params.purpose === "after_call" && params.canApprove && !params.alreadyLinked;
}
